
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active">
        <template #header>
          <h4 class="not-margin">
            Desvincular 
          </h4>
        </template>

        <div>
            <h6 class="text-center">¿Esta seguro de desvincular? </h6>
            <p>Los padres y/o tutores <strong>serán desvinculados</strong> del alumno <strong>{{infoHermano.nombre}}</strong></p>
        </div>

        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false"
                        style="width: 95%"
                    >
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col lg="6">
                    <vs-button
                        success
                        @click="postDesvincularFamiliar()"
                        style="width: 95%"
                    >
                        Aceptar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>

<script>
import servicios from '../../../../../api/requests/servicios'
export default {
    props:[
        'value',
        'info',
        'infoHermano'
    ],
    data(){
        return{
            active: false,
        }
    },
    methods: {
        async postDesvincularFamiliar(){
            const loading = this.$vs.loading()
            const vue = this
            try{
                const familiares = Object.values(this.info.familiares)
                console.log(this.infoHermano)
                const familiar = familiares.map(e => e.familiar_id)
                const user = familiares.map(e => e.user_id)
                console.log(familiar)
                console.log(user)
                const payload = {
                    hermano_persona_id: this.infoHermano.hermano_persona_id,
                    user_id: user,
                    familiar_id: familiar
                }
                const response = await servicios.postDesvincularFamiliar(payload)
                loading.close()
                vue.$emit('refreshTable')
                vue.active = false
                vue.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: 'Se desvinculo correctamente al alumno'
                })
            }catch(error){
                console.error(error)
                loading.close()
                vue.active = false
                vue.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Hubo un problema',
                    text: 'Favor de contactar al administrador'
                })
            }
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>